import { ApproversResponse } from "@api";
import { StyledTableCell } from "@components";
import { UpdateApprover } from "./updateApprover";
import { faCheckCircle, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Edit as EditIcon } from "@material-ui/icons";
import { IconButton } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontStyle: "italic",
  },
  green: {
    color: "green",
  },
  blue: {
    color: "#0f7dca",
  },
}));

interface Props {
  approvers: ApproversResponse;
  userEmail: string | null;
  headerId: number;
  status: string | null;
  handleUpdate: () => void;
}

export const ApproversDetails: React.FC<Props> = ({
  approvers,
  headerId,
  userEmail,
  status,
  handleUpdate,
}) => {
  const classes = useStyles();
  const [openUpdateApprover, setOpenUpdateApprover] = useState<boolean>(false);
  const {
    approver1,
    approvalDistroName1,
    approvedBy1,
    approver2,
    approvalDistroName2,
    approvedBy2,
    approver3,
    approvalDistroName3,
    approvedBy3,
    approver4,
    approvalDistroName4,
    approvedBy4,
  } = approvers;

  const [selectedApprovers, setSelectedApprovers] = useState<
    ApproversResponse
  >();

  function openAndSetSelectedApproversForUpdate(
    selectedApprover: ApproversResponse
  ) {
    selectedApprover.approverDistro2 = selectedApprover.approver2
      ? 0
      : selectedApprover.approverDistro2;
    selectedApprover.approverDistro3 = selectedApprover.approver3
      ? 0
      : selectedApprover.approverDistro3;
    selectedApprover.approverDistro4 = selectedApprover.approver4
      ? 0
      : selectedApprover.approverDistro4;

    setSelectedApprovers(selectedApprover);
    setOpenUpdateApprover(true);
  }

  let approver1Icon = null;
  const approver1Text = !!approvedBy1
    ? approvedBy1
    : !!approver1
    ? approver1
    : approvalDistroName1;

  const approver2Text = !!approvedBy2
    ? approvedBy2
    : !!approver2
    ? approver2
    : approvalDistroName2;

  const approver3Text = !!approvedBy3
    ? approvedBy3
    : !!approver3
    ? approver3
    : approvalDistroName3;

  const approver4Text = !!approvedBy4
    ? approvedBy4
    : !!approver4
    ? approver4
    : approvalDistroName4;

  if (!!approver1 || !!approvalDistroName1) {
    if (!!approvedBy1) {
      approver1Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else {
      approver1Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  let approver2Icon = null;

  if (!!approver2 || !!approvalDistroName2) {
    console.info("approvedBy2:"+approvedBy2);
    if (!!approvedBy2) {
      console.info("approvedBy2:"+approvedBy2);
      approver2Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else if (!!approver2 || !!approvalDistroName2) {
      approver2Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  let approver3Icon = null;

  if (!!approver3 || !!approvalDistroName3) {
    if (!!approvedBy3) {
      approver3Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else if (!!approver3 || !!approvalDistroName3) {
      approver3Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  let approver4Icon = null;

  if (!!approver4 || !!approvalDistroName4) {
    if (!!approvedBy4) {
      approver4Icon = (
        <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />
      );
    } else if (!!approver4 || !!approvalDistroName4) {
      approver4Icon = (
        <FontAwesomeIcon icon={faClock} className={classes.blue} />
      );
    }
  }

  let selUpdatApproversModal = null;
  if (!!selectedApprovers) {
    selUpdatApproversModal = (
      <UpdateApprover
        isOpen={openUpdateApprover}
        closeModal={() => setOpenUpdateApprover(false)}
        approvers={approvers}
        headerId={headerId}
        userEmail={userEmail}
        onUpdate={handleUpdate}
      />
    );
  }

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1">Approvers</Typography>
      </Grid>
      {selUpdatApproversModal}
      <Grid item xs={12}>
        <Typography
          variant="body1"
          color="textSecondary"
          className={classes.root}
        >
          <Box component="span">
            <Box component="span">
              <FontAwesomeIcon icon={faClock} className={classes.blue} />{" "}
              Approval in Progress
            </Box>
            <Box component="span" ml={3}>
              <FontAwesomeIcon icon={faCheckCircle} className={classes.green} />{" "}
              Approved
            </Box>
          </Box>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">Approver 1</StyledTableCell>
                <StyledTableCell align="center">Approver 2</StyledTableCell>
                <StyledTableCell align="center">Approver 3</StyledTableCell>
                <StyledTableCell align="center">Approver 4</StyledTableCell>
                <StyledTableCell align="center"></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center">
                  {approver1Icon} {approver1Text}
                </TableCell>
                <TableCell align="center">
                  {approver2Icon} {approver2Text}
                </TableCell>
                <TableCell align="center">
                  {approver3Icon} {approver3Text}
                </TableCell>
                <TableCell align="center">
                  {approver4Icon} {approver4Text}
                </TableCell>
                <TableCell>
                  <IconButton
                    size="small"
                    disabled={
                      status === "COMPLETED" ||
                      status === "REJECTED" ||
                      status === "DECLINED" ||
                      status === "USER DECLINED ATTESTATION"
                    }
                    onClick={() => {
                      openAndSetSelectedApproversForUpdate(approvers);
                    }}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
